import React from "react"
import { Col, Row } from "reactstrap"
import SlotCard from "./SlotCard"

import {
   getDynamicSlotWidth,
   getSlotTypePercentage,
} from "./ProductionSchedule.utils"

const ProductionDayGrid = props => {
   const {
      date = "Monday 4/26/2021",
      totalSlots = 4,
      premiumSlots = 0,
      regularSlots = 0,
      isOverride,
      slotsByStage = {},
      sortedSlotsByStage,
      onSlotClick = () => { },
   } = props

   const slotsByStageArray = sortedSlotsByStage || Object.entries(slotsByStage)
   const dynamicSlotWidth = getDynamicSlotWidth(totalSlots)
   const premiumPercentage = getSlotTypePercentage(premiumSlots, totalSlots)
   const regularPercentage = getSlotTypePercentage(regularSlots, totalSlots)


   return (
      <div className="production-day">
         <div className="production-day-date">{date}</div>{" "}
         <div className="production-day-override">
            {isOverride ? "Override" : ""}
         </div>
         <Row className="mb-0 production-day-slot-type">
            {premiumSlots > 0 && (
               <div
                  style={{ width: `${premiumPercentage}%` }}
                  className="production-day-slot-type-premium"
               >
                  Premium
               </div>
            )}
            {regularSlots > 0 && (
               <div
                  style={{ width: `${regularPercentage}%` }}
                  className="production-day-slot-type-regular"
               >
                  Regular
               </div>
            )}
         </Row>
         {slotsByStageArray.map(([stageId, stageSlots]) => (
            <Row className="production-day-row" key={stageId}>
               {stageSlots.map((slot, idx) => (
                  <Col
                     xs={dynamicSlotWidth}
                     className="production-day-row-column"
                     key={`${stageId}-${idx}`}
                  >
                     <SlotCard
                        {...slot}
                        index={idx}
                        onClick={onSlotClick}
                        slot={slot}
                     />
                  </Col>
               ))}
            </Row>
         ))}
      </div>
   )
}

export default ProductionDayGrid
